export default __webpack_public_path__ + "static/media/more.6e2172c6.svg";